<form [formGroup]="trafficSourceForm" (ngSubmit)="onSubmit()">
  <label>Nazwa</label>
  <input type="text" formControlName="name" />
  <label>Adres</label>
  <input formControlName="domain" />
  <button type="submit">Dodaj</button>
</form>
